import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import PalavrasDiretorExecutivo from "@/components/PalavrasDiretorExecutivo";
import Arrecadacao from "@/components/Arrecadacao";
import Distribuicao from "@/components/Distribuicao";
import AnaliseDiretorDeOperacoes from "@/components/AnaliseDiretorDeOperacoes";
import OsNumeros2025 from "@/components/OsNumeros2025";
import AtividadesPrincipais from "@/components/AtividadesPrincipais";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/Hotsite/Relatorio_Anual/2025/",
  // base: '/vialactea/relatorio_ubc2024/',
  routes: [
    { path: "/", name: "Home", component: Home },
    {
      path: "/PalavrasDiretorExecutivo",
      name: "PalavrasDiretorExecutivo",
      component: PalavrasDiretorExecutivo,
    },
    { path: "/Arrecadacao", name: "Arrecadacao", component: Arrecadacao },
    { path: "/Distribuicao", name: "Distribuicao", component: Distribuicao },
    {
      path: "/AnaliseDiretorDeOperacoes",
      name: "AnaliseDiretorDeOperacoes",
      component: AnaliseDiretorDeOperacoes,
    },
    { path: "/OsNumeros2025", name: "OsNumeros2025", component: OsNumeros2025 },
    {
      path: "/AtividadesPrincipais",
      name: "AtividadesPrincipais",
      component: AtividadesPrincipais,
    },
  ],
});
